// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"826":"6870f024","913":"90ff5d3f"}[chunkId] + ".chunk.js";
};